import axios from "axios"
import store from '../store'
import stringCaseUtil from '@/utils/stringCase'
import dataUtil from '@/utils/data'

// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = process.env.VUE_APP_ROOT_API;

const instance = axios.create({
    baseURL
})

const urlsNoAuthorization = [
    '/api/administracao/autenticacao/login'
]

instance.interceptors.request.use(config => {

    const customer = store.getters.getCustomer || null
    const autenticacao = store.getters.getAutenticacao || {}

    config.headers['customer'] = customer && customer.link ? customer.link : null

    if (customer && autenticacao.token && urlsNoAuthorization.indexOf(config.url) == -1) {

        config.headers['Authorization'] = 'Bearer ' + autenticacao.token
    }

    return config
}, error => Promise.reject(error))

instance.interceptors.response.use(config => {

    if(config.config.responseType == 'arraybuffer') {
        return config
    }

    if (config.data !== undefined
        && config.data !== null
        && (Array.isArray(config.data) || dataUtil.isObject(config.data))
    ) {

        config.data = stringCaseUtil.snakeObjectKeysToCamelRecursive(config.data)
    }

    return config
}, error => Promise.reject(error))

export default instance